;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product.show')
    .controller('ProductShowToolbarController', ProductShowToolbarController)

  ProductShowToolbarController.$inject = [
    // Angular
    '$state', 'urls', '$http',

    // Manager
    'InvoiceManager', 'QuoteManager',

    // Services
    'DisplayService', 'SnackService', 'TemplateService',

    // Resolve
    'product'

  ]

  function ProductShowToolbarController (
    // Angular
    $state, $urls, $http,

    // Manager
    InvoiceManager, QuoteManager,

    // Services
    DisplayService, SnackService, TemplateService,

    // Resolve
    product

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        product: product,
        reference: product.reference,

        // Methods
        deleteProduct: deleteProduct
      })
    }

    function deleteProduct (productId) {
      TemplateService.getAllPrefilledTemplates([productId]).then((templates) => {
        if (templates['invoices'] || templates['quotes']) {
          DisplayService.displayConfirm('Supprimer', 'Attention, ce produit figure dans certain(e)s de vos factures ou devis pré-remplis, si vous le supprimez, il le sera aussi de ces derniers ! <br><br>' +
          'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER').then(() => {
            const url = $urls.api + '/kilo/products/bulkProductDeletion'
            $http.put(url, { ids: [productId], templates: templates }).then(() => {
              $http.delete(`${self.product.rootUrl}/${self.product._id}`, { ignoreErrors: [409] }).then(function () {
                SnackService.snack({
                  text: 'Produit supprimé !',
                  delay: 5000
                })
                $state.go('product.list')
              })
            })
          }).catch(() => {
            return hasStockError()
          })
        } else {
          DisplayService.confirmDeletion().then(function () {
            $http.delete(`${self.product.rootUrl}/${self.product._id}`, { ignoreErrors: [409] }).then(function () {
              SnackService.snack({
                text: 'Produit supprimé !',
                delay: 5000
              })
              $state.go('product.list')
            }).catch(() => {
              return hasStockError()
            })
          })
        }
      })
    }

    function hasStockError () {
      return SnackService.snack({
        text: 'Ce produit possède encore des stocks, veuillez supprimer les stocks du produit sur LIFO avant de supprimer le produit.',
        delay: 15000,
        color: 'red',
        icon: 'mdi-alert-outline'
      })
    }
  }
})(window.angular, window._)
